import React from "react";
import { Navigate } from "react-router-dom";
// eslint-disable-next-line import/no-named-default
import { default as SettingsComponent } from "components/Settings";
import CompanyAdminSettingsComponent from "components/CompanyAdminSettings";
import TeamsComponent from "components/Teams";
import IntegrationSection from "components/IntegrationSection";
import HubSettingsComponent from "components/HubSettings";

const prebuiltComponents = {
  IntegrationSection,
  HubSettings: HubSettingsComponent,
  CompanyAdminSettings: CompanyAdminSettingsComponent,
  TeamsSettings: TeamsComponent,
  KpisSettings: ({ tabId }) => <Navigate to={`/${tabId}`} />,
};

const Settings = () => <SettingsComponent prebuiltComponents={prebuiltComponents} />;

export default Settings;
